/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { ReactComponent as SvgLogo } from "../../assets/Group.svg";
import { ReactComponent as SvgBlocksBlack } from "../../assets/row-vertical.svg";
import { ReactComponent as ChartLineUp } from "../../assets/analytics/ChartLineUp.svg";
// import { ReactComponent as GlobeIcon } from "../../assets/landingPages/header/globe.svg";

import { ReactComponent as Appearance } from "../../assets/Appearance.svg";
import { ReactComponent as Location } from "../../assets/map/location.svg";

import { ReactComponent as Rectangle11 } from "../../assets/Rectangle 11.svg";
import { ReactComponent as Logout } from "../../assets/Logout.svg";
import { ReactComponent as LogoutDark } from "../../assets/Logout-dark.svg";
import { ReactComponent as Settings } from "../../assets/Settings.svg";
import { ReactComponent as Regular } from "../../assets/InvitationSystem/Regular.svg";
import { ReactComponent as Ellipse47 } from "../../assets/InvitationSystem/Ellipse47.svg";

import { useStateContext } from "../../contexts/ThemeContext";
import useLocales from "../../hooks/useLocales";
import useSettings from "../../hooks/useSettings";
import { useSelector } from "react-redux";
// import { darkMode } from '../../../tailwind.config';

// Dashboard pages menu items component

const ImageUrl = process.env.REACT_APP_API_URL;
const Sidebar = ({ handleAdminLogout }) => {
  const { translate } = useLocales();
  const { themeDirection } = useSettings();
  const {
    activeMainPageNav,
    activeAppearancePageNav,
    activeSettingPageNav,
    activeInvitionSystemPageNav,
    activeUpgradeAnalyticsPageNav,
    activeLocationNav,
  } = useStateContext();
  //  default values for profile
  const user_data = useSelector(
    (state) => state?.adminUser?.viewUserData?.user_data
  );
  const { darkMode } = useSelector((state) => state.theme);

  const { totalInvites } = useSelector((state) => state?.invitationListEmails);

  const activeLink =
    "p-[13px] bg-gradient-to-tl from-[#000000] to-[#494949] rounded-[10px]";

  return (
    <>
      <div
        style={{ zIndex: "9999" }}
        className="relative h-screen md:overflow-hidden overflow-auto md:hover:overflow-auto pb-0"
      >
        <div className="h-[100vh] px-5 flex flex-col justify-between gap-[45px] items-center">
          <div className="flex flex-col items-center">
            <div className="mt-[30px] flex justify-center items-center">
              <Link to="/">
                <div>
                  <SvgLogo width={45} />
                </div>
              </Link>
            </div>
            <NavLink
              to={"/dashboard/component"}
              className={({ isActive }) =>
                isActive
                  ? `${activeLink} mt-[46px] mb-10`
                  : "bg-transparent mt-[59px] mb-10" && activeMainPageNav
                  ? `${activeLink} mt-[46px] mb-10`
                  : "bg-transparent mt-[59px] mb-10"
              }
              title={translate("components")}
            >
              {/*<RxDashboard />*/}
              <SvgBlocksBlack
                className={`${
                  darkMode
                    ? "stroke-white"
                    : activeMainPageNav
                    ? "stroke-white"
                    : "stroke-heading_color"
                }`}
              />
            </NavLink>

            <NavLink
              to={"/dashboard/appearance"}
              className={({ isActive }) => (isActive ? activeLink : "")}
              title={translate("cms.appearance")}
            >
              <Appearance
                className={`${
                  darkMode
                    ? "stroke-white"
                    : activeAppearancePageNav
                    ? "stroke-white"
                    : "stroke-heading_color"
                }`}
              />
            </NavLink>
            <NavLink
              to={"/dashboard/analytics"}
              className={({ isActive }) =>
                isActive
                  ? `${activeLink} mt-[46px] mb-10`
                  : "bg-transparent mt-[59px] mb-10" &&
                    activeUpgradeAnalyticsPageNav
                  ? `${activeLink} mt-[46px] mb-10`
                  : "bg-transparent mt-[59px] mb-10"
              }
              // title={translate("")}
              title="analytics"
            >
              <ChartLineUp
                className={`${
                  darkMode
                    ? "stroke-white"
                    : activeUpgradeAnalyticsPageNav
                    ? "stroke-white"
                    : "stroke-heading_color"
                }`}
              />
            </NavLink>
          </div>

          <div className="mb-[30px] flex flex-col gap-8 items-center">
            <div className="flex flex-col justify-center gap-[34px] items-center">
              <NavLink
                to={"/dashboard/invitionSystem"}
                className={({ isActive }) =>
                  isActive ? activeLink : "text-gray-800 text-2xl"
                }
              >
                {/* <div
                  className=" flex justify-center items-center"
                  title={translate("Invitation_System.invite_friend")}
                >
                  <Regular
                    className={`drop-shadow-xl cursor-pointer ${
                      activeInvitionSystemPageNav
                        ? "stroke-white"
                        : " stroke-heading_color"
                    }`}
                  />
                  <Ellipse47 />
                  <p className="text-main_color text-xs mr-[-5px] mb-1.5 font-normal not-italic tracking-[-0.3px]">
                    2
                  </p>
                </div> */}
                <div
                  className=" flex justify-center items-center"
                  title={translate("Invitation_System.invite_friend")}
                >
                  <div className="relative inline-flex w-fit">
                    <div className="absolute bottom-auto left-auto right-0 top-0 z-10 -translate-y-1/2 translate-x-2/4 rotate-0 skew-x-0 skew-y-0 scale-x-100 scale-y-100 rounded-full bg-main_color p-2.5 w-3 h-3 justify-center items-center flex">
                      <p className="text-[10px] leading-[13px] font-normal not-italic tracking-[-0.3px] text-light_bg_v5">
                        {totalInvites}
                      </p>
                    </div>
                    <Regular
                      className={`drop-shadow-xl cursor-pointer ${
                        darkMode
                          ? "stroke-white"
                          : activeInvitionSystemPageNav
                          ? "stroke-white"
                          : " stroke-heading_color"
                      }`}
                    />
                  </div>
                </div>
              </NavLink>
              <NavLink
                to={"/dashboard/setting"}
                className={({ isActive }) =>
                  isActive ? activeLink : "text-gray-800 text-2xl"
                }
              >
                <div
                  className=" flex justify-center items-center"
                  title={translate("biolink_title.settings")}
                >
                  <Settings
                    className={`drop-shadow-xl cursor-pointer ${
                      darkMode
                        ? "stroke-white"
                        : activeSettingPageNav
                        ? "stroke-white"
                        : " stroke-heading_color"
                    }`}
                  />
                </div>
              </NavLink>
              {darkMode ? (
                <LogoutDark
                  className={`drop-shadow-xl cursor-pointer ${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                  onClick={handleAdminLogout}
                  // onClick={() => setIsModalOpen(true)}
                  title={translate("header.logout")}
                />
              ) : (
                <Logout
                  className={`drop-shadow-xl cursor-pointer ${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                  onClick={handleAdminLogout}
                  // onClick={() => setIsModalOpen(true)}
                  title={translate("header.logout")}
                />
              )}
            </div>
            <div className="flex justify-center items-center">
              <Link to={"/dashboard/setting/account"}>
                {user_data?.profile_image ? (
                  <img
                    className="h-[50px] max-h-[50px] max-w-[50px] w-[50px] object-cover rounded-[10px]"
                    src={`${ImageUrl}/profile/${user_data?.profile_image}`}
                    alt="profileImage"
                    title="Profile Image"
                  />
                ) : (
                  <Rectangle11 className="drop-shadow-md" />
                )}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
